<template>
  <div class="register-container candidate-register">
    <div v-if="!hasCompany && accountType !== ACCOUNT_TYPE.CANDIDATE" class="container-title">{{ $t('login.common.title.register') }}</div>
    <div v-if="!hasCompany && accountType !== ACCOUNT_TYPE.CANDIDATE" class="container-sub-title">
      <span>{{  $t('login.common.message.loginTip.hasAccount') }}</span>
      <router-link class="link" :to="{ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register`, query: $route.query, hash: $route.hash }">{{ $t('login.common.message.loginTip.login') }}</router-link>
    </div>
    <div class="content-form register-form">
      <transition-group name="el-fade-in-linear">
        <div class="form-line" key="phone" :class="getErrorClass(message.phone)">
          <el-input
            v-model="phone"
            class="line-input phone-input"
            :placeholder="$t('login.common.placeholder.phone')"
            @focus="clearErrorMessage(message.phone)"
            @blur="validate(message.phone)"
            @change="validate(message.phone)"
          >
            <template #prepend>
              <el-select
                v-model="countryCode"
                class="country-code"
                filterable
                :popper-class="isMobile ? 'is-mobile-el-select' : null"
                :filter-method="searchCountryCode"
                @visible-change="resetSearchedCountryCodeList"
              >
                <el-option
                  v-for="(code) in searchedCountryCodeList"
                  class="country-code-option"
                  :style="customStyle"
                  :key="code.country_id"
                  :value="code.countryCode"
                >
                  <span class="country-name">{{ code.countryName }}</span>
                  <span class="country-code-label">{{ code.countryCode }}</span>
                </el-option>
              </el-select>
            </template>
          </el-input>
          <div v-show="message.phone.show" class="line-tip">{{ selectLabelI18n(message.phone, 'text') }}</div>
        </div>
        <div v-if="countryCode === CHINA_COUNTRY_CODE" class="form-line" key="verifyCode" :class="getErrorClass(message.verifyCode)">
          <PhoneVerifyCodeInput
            v-model="verifyCode"
            class="line-input"
            :phone="phone"
            :captchaIndex="2"
            :placeholder="$t('login.common.label.verifyCode')"
            @focus="clearErrorMessage(message.verifyCode)"
            @blur="validate(message.verifyCode)"
            @change="validate(message.verifyCode)"
            @sendVerifySuccess="handelSendVerifySuccess"
          />
          <div v-show="message.verifyCode.show" class="line-tip">{{ selectLabelI18n(message.verifyCode, 'text') }}</div>
        </div>
        <div v-if="countryCode !== CHINA_COUNTRY_CODE" class="form-line has-sub-form-line" key="firstName">
          <div class="sub-form-line" :class="getErrorClass(message.firstName)">
            <el-input
              v-model="firstName"
              class="line-input"
              :placeholder="$t('login.common.label.firstName')"
              @focus="clearErrorMessage(message.firstName)"
              @blur="validate(message.firstName)"
              @change="validate(message.firstName)"
            ></el-input>
            <div v-show="message.firstName.show" class="line-tip">{{ selectLabelI18n(message.firstName, 'text') }}</div>
          </div>
          <div class="sub-form-line" :class="getErrorClass(message.lastName)" key="lastName">
            <el-input
              v-model="lastName"
              class="line-input"
              :placeholder="$t('login.common.label.lastName')"
              @focus="clearErrorMessage(message.lastName)"
              @blur="validate(message.lastName)"
              @change="validate(message.lastName)"
            ></el-input>
            <div v-show="message.lastName.show" class="line-tip">{{ selectLabelI18n(message.lastName, 'text') }}</div>
          </div>
        </div>
        <div v-if="countryCode !== CHINA_COUNTRY_CODE" class="form-line" key="email" :class="getErrorClass(message.email)">
          <el-input
            v-model="email"
            name="account"
            class="line-input"
            :placeholder="$t('login.common.label.email')"
            @focus="clearErrorMessage(message.email)"
            @blur="validate(message.email)"
            @change="validate(message.email)"
          ></el-input>
          <div v-show="message.email.show" class="line-tip">{{ selectLabelI18n(message.email, 'text') }}</div>
        </div>
        <div v-if="countryCode !== CHINA_COUNTRY_CODE" class="form-line" key="password" :class="getErrorClass(message.password)">
          <el-input
            v-model="password"
            ref="password"
            class="line-input"
            autocomplete="new-password"
            :type="viewPassword ? 'text' : 'password'"
            :placeholder="$t('login.common.placeholder.createPassword')"
            @focus="clearErrorMessage(message.password)"
            @blur="validate(message.password)"
            @change="validate(message.password)"
          >
            <template #suffix>
              <i class="password-icon iconfont" :class="viewPassword ? 'iconVisible' : 'iconHide1'" @click="onViewPassword"></i>
            </template>
          </el-input>
          <div v-show="message.password.show" class="line-tip">{{ selectLabelI18n(message.password, 'text') }}</div>
        </div>
      </transition-group>
    </div>
    <div class="button-container">
      <el-button class="register-btn" type="primary" @click="onRegisterBtnClick">{{ $t('login.common.btn.register.candidate') }}</el-button>
    </div>
    <div class="form-bottom">
      <div class="bottom-line">
        <el-checkbox v-model="agree" class="policy-checkbox">
          <span>{{ $t('login.common.message.policy.tip') }}</span>
          <a class="link" href="/tos/" target="_blank">{{ $t('login.common.message.policy.userAgreement') }}</a>
          <span> & </span>
          <a class="link" href="/policy/" target="_blank">{{ $t('login.common.message.policy.privacyPolicy') }}</a>
        </el-checkbox>
        <div class="line-tip"></div>
      </div>
    </div>
    <div v-if="company?.root_company_id !== ROOT_COMPANY_ID.MERCEDES_BENZ" class="other-account-container">
      <div class="split-line">
        <span class="line-text">{{ $t('login.common.label.loginOtherAccount') }}</span>
      </div>
      <div class="other-account-list">
        <el-tooltip v-if="!onlyShowLinkedin" effect="light" popper-class="light-tooltip-popper" :content="$t('login.common.label.otherAccount.51job')">
          <router-link class="other-account 51job" :to="{ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/${THIRD_PARTY_CHANNEL_TYPE_51}/third-party`, query: $route.query, hash: $route.hash }">
            <i class="account-icon iconfont icona-51job"></i>
          </router-link>
        </el-tooltip>
        <el-tooltip v-if="!onlyShowLinkedin" effect="light" popper-class="light-tooltip-popper" :content="$t('login.common.label.otherAccount.facebook')">
          <span class="other-account facebook" @click="onFacebookIconClick">
            <i class="account-icon iconfont iconfacebook"></i>
          </span>
        </el-tooltip>
        <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="$t('login.common.label.otherAccount.linkedin')">
          <a class="other-account linkedin" target="_blank" rel="opener" :href="linkedinLoginLink">
            <i class="account-icon iconfont iconLinkedin1"></i>
          </a>
        </el-tooltip>
        <el-tooltip v-if="!onlyShowLinkedin" effect="light" popper-class="light-tooltip-popper" :content="$t('login.common.label.otherAccount.jobStreet')">
          <router-link class="other-account jobstreet" :to="{ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/${THIRD_PARTY_CHANNEL_TYPE_JOBSTREET}/third-party`, query: $route.query, hash: $route.hash }">
            <i class="account-icon iconfont iconGongzuojie1"></i>
          </router-link>
        </el-tooltip>
      </div>
    </div>
    <DialogWrapper
      class="email-dialog"
      :show.sync="showEmailDialog"
      :loading="emailDialogLoading"
      :titleI18nKey="'login.common.title.emailDialog'"
      :closeOnClickModal="false"
      :saveBtnLabelI18nKey="'login.common.btn.useEmailLogin'"
      :cancelBtnLabelI18nKey="'login.common.btn.continueRegister'"
      :width="isMobile ? '80%' : '40%'"
      @save="handleUseEmailLogin"
      @cancel="handleContinueLogin"
    >
      <el-radio-group v-model="bindAccountId" class="email-list">
        <el-radio v-for="(info, index) in existAccountInfoList" class="email-item" :label="info.id" :key="index">
          <span class="label">{{ info.email }}</span>
          <span v-if="info.last_login_time" class="time">{{ $t('login.common.label.lastLoginTime', {time: formatTime(info.last_login_time) })  }}</span>
        </el-radio>
      </el-radio-group>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { ACCOUNT_TYPE, CHINA_COUNTRY_CODE } from '@/constant/common'
import { mixedRouterPush } from '@/router/routes'
import { validateEmail, validatePassword, validatePhone } from '@/utils/validator'
import { THIRD_PARTY_CHANNEL_TYPE_51, THIRD_PARTY_CHANNEL_TYPE_JOBSTREET } from '@/constant/thirdParty'
import { deviceType } from '@/utils/common'
import { passwordEncrypt } from '@/utils/rsa'
import PhoneVerifyCodeInput from '@/components/formEditor/phoneVerifyCodeInput.vue'
import { selectLabelI18n } from '@/i18n'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import moment from 'moment'
import { ROOT_COMPANY_ID } from '@/constant/company'

export default {
  components: {
    DialogWrapper,
    PhoneVerifyCodeInput
  },
  props: {
    company: {
      type: Object,
      default: null
    },
    linkedinLoginLink: {
      type: String,
      default: null
    },
    onlyShowLinkedin: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: null
    },
    facebookSDKLoader: {
      type: Promise,
      default: null
    }
  },
  data () {
    return {
      THIRD_PARTY_CHANNEL_TYPE_51,
      THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
      CHINA_COUNTRY_CODE,
      ROOT_COMPANY_ID,
      selectLabelI18n,
      ACCOUNT_TYPE,
      isMobile: deviceType.isMobile,
      firstName: null,
      lastName: null,
      email: null,
      countryCode: CHINA_COUNTRY_CODE,
      phone: null,
      verifyCode: null,
      password: null,
      agree: false,
      viewPassword: false,
      hasSentVerifyCode: false,
      searchedCountryCodeList: [],
      message: {
        firstName: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        },
        lastName: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        },
        email: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        },
        phone: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        },
        verifyCode: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        },
        password: {
          show: false,
          isError: false,
          text: null,
          textI18nKey: null
        }
      },
      facebookLoginLink: null,
      showEmailDialog: false,
      emailDialogLoading: false,
      existAccountInfoList: [],
      checkExistAccountEmail: true,
      bindAccountId: null
    }
  },
  computed: {
    accountType () {
      return this.$route.meta?.accountType || this.$route.params.accountType
    },
    companyId () {
      return this.company?.id
    },
    applyJobId () {
      return this.$route.query.apply_job_id
    },
    hasCompany () {
      return Boolean(this.companyId)
    },
    countryCodeList () {
      return this.$parent.countryCodeList
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('account', ['doCandidateRegister', 'getThirdPartyLoginInfo', 'login']),
    // ...mapActions('account', ['login', 'checkSSO', 'getLogonAccountNextPage', 'getThirdPartyLoginInfo']),
    async initPage () {
      this.searchCountryCode()
    },
    searchCountryCode (text) {
      if (!text) {
        this.searchedCountryCodeList = this.countryCodeList
        return
      }
      text = text.toLocaleLowerCase()
      this.searchedCountryCodeList = _.filter(this.countryCodeList, code => _.some(code.keywords, keyword => keyword.includes(text)))
    },
    resetSearchedCountryCodeList (visible) {
      if (!visible) {
        this.searchedCountryCodeList = this.countryCodeList
      }
    },
    onViewPassword () {
      this.viewPassword = !this.viewPassword
    },
    getErrorClass (message) {
      return message && message.show && message.isError && 'has-error'
    },
    setErrorMessage (message, textI18nKey, getter) {
      if (getter) {
        Object.defineProperty(message, 'text', {
          configurable: true,
          enumerable: true,
          get: getter
        })
      } else {
        message.text = null
      }
      message.isError = true
      message.textI18nKey = textI18nKey
      message.show = true
    },
    clearErrorMessage (message) {
      message.show = false
      message.isError = false
      message.text = null
      message.textI18nKey = null
    },
    validate (message) {
      if (!message) {
        return !_.chain(this.message).map(this.validate).includes(false).value()
      }
      let hasError = false
      let textI18nKey = null
      const getter = null
      if (message === this.message.firstName && this.countryCode !== CHINA_COUNTRY_CODE) {
        if (!this.firstName) {
          hasError = true
          textI18nKey = 'login.common.placeholder.firstName'
        }
      } else if (message === this.message.lastName && this.countryCode !== CHINA_COUNTRY_CODE) {
        if (!this.lastName) {
          hasError = true
          textI18nKey = 'login.common.placeholder.lastName'
        }
      } else if (message === this.message.email && this.countryCode !== CHINA_COUNTRY_CODE) {
        if (this.email) {
          if (validateEmail(null, this.email)) {
            hasError = true
            textI18nKey = 'common.message.invalidEmail'
          }
        } else {
          hasError = true
          textI18nKey = 'login.common.placeholder.email'
        }
      } else if (message === this.message.phone) {
        if (this.phone) {
          if (this.countryCode === CHINA_COUNTRY_CODE && validatePhone(null, this.phone)) {
            hasError = true
            textI18nKey = 'common.message.invalidMobile'
          }
        } else {
          hasError = true
          textI18nKey = 'login.common.placeholder.phone'
        }
      } else if (this.countryCode === CHINA_COUNTRY_CODE && message === this.message.verifyCode) {
        if (this.hasSentVerifyCode) {
          if (this.verifyCode && !/^\d{0,6}$/.test(this.verifyCode)) {
            this.verifyCode = null
          } else if (!this.verifyCode) {
            hasError = true
            textI18nKey = 'login.common.placeholder.verifyCode'
          }
        } else {
          hasError = true
          textI18nKey = 'login.common.message.getVerifyCodeFirst'
        }
      } else if (message === this.message.password && this.countryCode !== CHINA_COUNTRY_CODE) {
        if (this.password) {
          if (validatePassword(null, this.password)) {
            hasError = true
            textI18nKey = 'login.common.message.passwordRule'
          }
        } else {
          hasError = true
          textI18nKey = 'login.common.placeholder.password'
        }
      }
      if (hasError) {
        this.setErrorMessage(message, textI18nKey, getter)
        return false
      } else {
        this.clearErrorMessage(message)
        return true
      }
    },
    async doLoginOrRegisterByPhone () {
      const data = {
        account_type: this.accountType,
        agree: this.agree,
        company_id: this.companyId,
        name: this.phone.trim(),
        sms_verify_code: this.countryCode === CHINA_COUNTRY_CODE ? this.verifyCode.trim() : null,
        country_code: this.countryCode,
        check_exist_account_email: this.checkExistAccountEmail,
        bind_account_id: this.bindAccountId,
        back: this.getBackUrl(),
        submit: this.$route.query.submit,
        apply_job_id: this.$route.query.apply_job_id,
        agreed_policy_items: this.$route.query.agreed_policy_items,
        redirect_job_id: this.$route.query.redirect_job_id,
        redirect_company_id: this.$route.query.redirect_company_id
      }
      const resp = await this.login(data)
      this.bindAccountId = null
      if (resp) {
        if (resp.sso_path) {
          window.location.href = resp.sso_path
        } else if (resp.success) {
          mixedRouterPush(resp.next_page || '/')
        } else {
          if (resp.exist_account_info_list) {
            this.existAccountInfoList = _.orderBy(resp.exist_account_info_list, [(item) => {
              if (!item.last_login_time) {
                return -1
              }
              return moment(item.last_login_time).valueOf()
            }], ['desc'])
            this.showEmailDialog = true
          } else if (resp.lock_countdown_time) {
            this.$message.error(this.$t('login.common.message.lockAccount.countdownTime', { countdownTime: parseInt(resp.lock_countdown_time) }))
          } else if (resp.lock_after) {
            this.$message.error(this.$t('login.common.message.lockAccount.lockAfter', { times: parseInt(resp.lock_after) }))
          } else {
            this.$message.error(this.$t('login.common.message.accountOrPasswordIsWrong'))
          }
        }
      }
    },
    async handleUseEmailLogin () {
      if (!this.bindAccountId) {
        this.$message.warning(this.$t('login.common.message.bindEmailRequired'))
        return
      }
      this.emailDialogLoading = true
      try {
        await this.doLoginOrRegisterByPhone()
      } finally {
        this.emailDialogLoading = false
      }
    },
    async handleContinueLogin () {
      this.checkExistAccountEmail = false
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.doLoginOrRegisterByPhone()
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async onRegisterBtnClick () {
      if (!this.agree) {
        this.$message.warning(this.$t('login.common.message.agreePolicyFirst'))
        return
      }
      if (!this.validate()) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        if (this.countryCode === CHINA_COUNTRY_CODE) {
          await this.doLoginOrRegisterByPhone()
        } else {
          await this.doRegister()
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async doRegister () {
      const params = {
        first_name: this.firstName.trim(),
        last_name: this.lastName.trim(),
        email_address: this.email.trim(),
        mobile: this.phone.trim(),
        password: passwordEncrypt(this.password),
        sms_validation_code: this.countryCode === CHINA_COUNTRY_CODE ? this.verifyCode.trim() : null,
        country_code: this.countryCode,
        company_id: this.companyId,
        agreed_policy_items: this.$route.query.agreed_policy_items,
        back: this.getBackUrl()
      }
      const resp = await this.doCandidateRegister(params)
      if (resp) {
        const backUrl = this.getBackUrl()
        if (backUrl) {
          mixedRouterPush(backUrl)
        }
        mixedRouterPush(resp.next_page)
      }
    },
    getFacebookUserInfoAndLogin (signedRequest) {
      const apiURL = 'https://graph.facebook.com/me?fields=email,id,first_name,last_name,middle_name,name,name_format,picture,short_name,birthday'
      window.FB.api(apiURL, (userInfo) => {
        userInfo = encodeURIComponent(JSON.stringify(userInfo))
        const originUrl = encodeURIComponent(window.location.href)
        window.location.href = `/facebook-login/?state=1&profile_info=${userInfo}&signed_request=${signedRequest}&origin_url=${originUrl}`
      }, { scope: 'email' })
    },
    async onFacebookIconClick () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.facebookSDKLoader
        const FB = window.FB
        FB.getLoginStatus((resp) => {
          if (resp.status === 'connected') {
            this.getFacebookUserInfoAndLogin(resp.authResponse.signedRequest)
          } else {
            FB.login((resp) => {
              if (resp.status === 'connected') {
                this.getFacebookUserInfoAndLogin(resp.authResponse.signedRequest)
              } else if (resp.status === 'authorization_expired') {
                // The user has signed into your application with
                // Facebook Login but must go through the login flow
                // again to renew data authorization. You might remind
                // the user they've used Facebook, or hide other options
                // to avoid duplicate account creation, but you should
                // collect a user gesture (e.g. click/touch) to launch the
                // login dialog so popup blocking is not triggered.
              } else if (resp.status === 'not_authorized') {
                // The user hasn't authorized your application.  They
                // must click the Login button, or you must call FB.login
                // in response to a user gesture, to launch a login dialog.
              } else {
                // The user isn't logged in to Facebook. You can launch a
                // login dialog with a user gesture, but the user may have
                // to log in to Facebook before authorizing your application.
              }
            })
          }
        })
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handelSendVerifySuccess () {
      this.hasSentVerifyCode = true
    },
    formatTime (time) {
      if (!time) {
        return
      }
      return moment(time).format('YYYY/MM/DD')
    },
    getBackUrl () {
      const query = this.$route.query
      return query.back ? `${query.back}${this.$route.hash}` : null
    }
  },
  watch: {
    countryCode () {
      if (this.countryCode !== CHINA_COUNTRY_CODE) {
        this.clearErrorMessage(this.message.verifyCode)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  .container-sub-title {
    margin-top: 14px;
    color: #909c99;
  }

  .content-form {
    margin-top: 24px;

    .form-line {
      min-height: 40px;
      margin-bottom: 24px;

      &.has-error {
        margin-bottom: 6px;

        .line-tip {
          padding-left: 0;
          color: #f56c6c;
        }

        .line-input {
          ::v-deep {
            > .el-input__inner {
              border-color: #f56c6c;
            }

            .verify-code {
              .el-input__inner {
                border-color: #f56c6c;
              }
            }

            .el-input__inner:hover + .el-input-group__prepend,
            .el-input__inner:hover + .el-input-group__append,
            .el-input-group__prepend,
            .el-input-group__append {
              border-color: #f56c6c;
            }
          }
        }
      }

      .sub-form-line {
        display: inline-block;
        width: 190px;
        height: 40px;
        vertical-align: middle;

        &.has-error {
          .line-tip {
            padding-left: 0;
            color: #f56c6c;
          }

          .line-input {
            ::v-deep {
              .el-input__inner {
                border-color: #f56c6c;
              }
            }
          }
        }

        + .sub-form-line {
          margin-left: 20px;
        }
      }

      .line-input {
        ::v-deep {
          &.el-input-group--prepend {
            .el-input__inner {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
          }

          .el-input__inner {

            &:focus {
              border-color: var(--custom-color, #0096cc);
            }
          }

          .verify-code {
            .el-input__inner {
              border-right: 0;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;

              &:hover + .el-input-group__append {
                border-color: #c0c4cc;
              }

              &:focus + .el-input-group__append {
                border-color: var(--custom-color, #0096cc);
              }

              &:focus {
                border-color: var(--custom-color, #0096cc);
              }
            }

            .el-input-group__append {
              padding-left: 0;
              padding-right: 14px;
            }

            .send-verify-code {
              color: var(--custom-color, #0096cc);
              cursor: pointer;

              &.has-sent {
                cursor: default;
              }
            }
          }

          .el-input__inner {
            border-radius: 2px;
            padding-left: 14px;
            padding-right: 35px;
          }

          .el-input__suffix {
            right: 14px;
          }

          .el-input-group__prepend {
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            background: initial;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
          }

          .el-input-group__append {
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;
            background: initial;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
          }
        }

        .country-code {
          width: 90px;
          color: #606266;

          ::v-deep {
            .el-input {
              .el-select__caret {
                color: #606266;
              }

              .el-input__inner {
                padding-right: 30px;
                border: 0;

                &:focus {
                  border: 0;
                }
              }

              .el-input__suffix {
                right: 5px;
              }
            }
          }
        }

        .password-icon {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          font-size: 14px;
          color: #909399;
        }
      }

      .line-tip {
        padding-left: 15px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  .button-container {

    .el-button {
      width: 100%;
      padding: 9px 0;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
      border: 0;
      background-color: var(--custom-color, #0096cc);
    }
  }

  .form-bottom {
    margin-top: 26px;

    .bottom-line {
      margin-bottom: 10px;

      .policy-checkbox {
        white-space: nowrap;

        .link {
          color: var(--custom-color, #0096cc);
        }

        ::v-deep {
          .el-checkbox__input {
            .el-checkbox__inner {
              width: 12px;
              height: 12px;

              &::after {
                top: 0;
                left: 3px;
              }
            }

            &.is-focus .el-checkbox__inner {
              border-color: var(--custom-color, #0096cc);
            }

            &.is-checked .el-checkbox__inner {
              background-color: var(--custom-color, #0096cc);
              border-color: var(--custom-color, #0096cc);
            }
          }

          .el-checkbox__label {
            white-space: initial;
            word-break: break-word;
            vertical-align: text-top;
            color: #606266;
            font-size: 12px;
            line-height: 19px;
          }
        }
      }
    }
  }

  .other-account-container {
    margin-top: 30px;
    margin-bottom: 10px;

    .split-line {
      height: 17px;
      line-height: 17px;
      text-align: center;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #dcdfe6;
        position: absolute;
        top: 9px;
        left: 0;
      }

      .line-text {
        padding: 0 6px;
        background: #ffffff;
        color: #909399;
        font-size: 12px;
        position: relative;
      }
    }

    .other-account-list {
      margin-top: 24px;
      text-align: center;

      .other-account {
        display: inline-block;
        color: #303133;
        cursor: pointer;

        .account-icon {
          font-size: 32px;
          line-height: 1;
        }

        & + .other-account {
          margin-left: 30px;
        }
      }
    }
  }
}

.country-code-option {
  display: flex;
  justify-content: space-between;

  .country-name {
    flex: 1;
  }

  .country-code-label {
    margin-left: 5px;
  }

  &.selected {
    color: var(--custom-color, #0096cc);
  }
}

.email-dialog {
  .email-list {
    display: flex;
    flex-direction: column;

    .email-item {
      margin-bottom: 4px;
      word-break: break-word;

      ::v-deep {
        .el-radio__input {
          height: 14px;
        }
      }

      .label {
        line-height: 20px;
      }

      .time {
        line-height: 20px;
      }
    }
  }
}

.is-mobile {
  .register-container {
    padding: 30px 25px;

    .container-title {
      font-size: 30px;
      line-height: 44px;
    }

    .register-form {
      .form-line {

        &.has-sub-form-line {
          display: flex;

          .sub-form-line {
            flex: 1;
            width: auto;
          }
        }
      }
    }

    .other-account-container {
      margin: 20px 0;

      .other-account-list {
        .other-account {
          .account-icon {
            font-size: 36px;
          }
        }
      }
    }
  }

  .email-dialog {
    ::v-deep {
      .el-dialog__footer {
        .dialog-footer {
          display: flex;
          flex-direction: column;
          align-items: center;

          .cancel-btn {
            margin-bottom: 10px;
          }

          .save-btn {
            margin: 0;
          }

          .footer-btn {
            width: 170px;
            padding: 10px 20px;
          }
        }
      }
    }

    .email-list {
      .email-item {
        ::v-deep {
          .el-radio__input {
            height: 14px;
            top: 4px;
            vertical-align: top;
          }

          .el-radio__label {
            white-space: normal;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
// to fix 在ios设备中，el-select组件下拉框，点击2次才能选中问题。
.is-mobile-el-select {
  .el-scrollbar {
    .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
}
</style>
